import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { checkRegions, CheckRegionsPayload } from '@/services/check-regions'

export const CHECK_REGIONS_KEY = 'check-regions'

interface CheckRegionsOptions {
  enabled?: boolean
}

export function useCheckRegions(
  payload: CheckRegionsPayload,
  options?: CheckRegionsOptions,
) {
  const query = useQuery({
    queryKey: [CHECK_REGIONS_KEY, payload],
    queryFn: () => checkRegions(payload),

    onError: (error: Error) => {
      toast.error(`Erro ao verificar polígonos: ${error.message}`)
    },

    cacheTime: 0,
    ...options,
  })

  return query
}
